import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    standalone: true,
    imports: [RouterModule, TranslateModule],
    selector: 'app-header',
    templateUrl: './app-header.component.html',
    styleUrls: ['./app-header.component.scss'],
    host: {
        class: 'header container',
    },
})
export class AppHeaderComponent {
    title = 'Extranet Account Provisioning System';

    constructor() {}
}
